<app-navbar></app-navbar>

<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">
      <!-- <app-samplecenter-sidebar></app-samplecenter-sidebar> -->

      <div class="card shadow custom-margin-right-box" style="width: 100%">
        <div class="card-header heading_n_button_box">
          <div class="card-heading">
            <h4>View Bookings</h4>
          </div>

          <!-- <div class="button-section mt-1">

                        <div class="dropdown">
                            <button class="mr-4 small-btn-dash dropdown-toggle" type="button" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Enrol Traveller
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" href="#">Arriving Equitorial Guinea</a>
                                <a class="dropdown-item" href="#">Departing Equitorial Guinea</a>
                            </div>
                        </div>
                    </div> -->
        </div>
        <div class="card-body">
          <div class="row">
          <div class="col-lg-12">
            <div class="d-flex justify-content-end mr-5 pr-4 mt-4"></div>

            <!-- <div class="col-lg-12">
              <h3 class="text-success">
                {{ todaysDate | date: "medium" }}
              </h3>
            </div> -->

            <div class="col-lg-12">
              <form
                [formGroup]="searchForm"
                (ngSubmit)="onSubmitSearch(searchForm.value)"
              >
                <div class="row">
                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                    <input
                      class="form-control font-12"
                      type="date"
                      formControlName="booking_date"
                      name="booking_date"
                      placeholder="Booking Date"
                    />
                  </div>

                  <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                    <div class="mr-4">
                      <button
                        class="btn btn-secondary theme-btn-2 dropdown-toggle-no"
                        type="submit"
                        id="dropdownMenuButton"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="fas fa-search"></i> Search
                      </button>

                      <button
                        class="
                          btn btn-secondary
                          theme-btn-2
                          dropdown-toggle-no
                          ml-2
                        "
                        type="button"
                        id="dropdownMenuButton"
                        aria-haspopup="true"
                        aria-expanded="false"
                        (click)="clearSearch()"
                      >
                        <i class="fas fa-sync-alt"></i> Clear
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!-- <h3 class="dashboard-heading-1">Passenger personal Information</h3> -->
            <div class="">
              <div class="table-responsive mt-3">
                <div class="col-auto">
                  <div class="row" *ngIf="bookings">
                    <div class="show-record mt-3 mbm-32">
                      <span>Show</span> &nbsp;
                      <select
                        class="
                          custom-select custom-select-sm
                          form-control form-control-sm
                        "
                        (change)="setItemsPerPage(page.value)"
                        #page
                      >
                        <option [selected]="currentPageLength == 10">10</option>
                        <option [selected]="currentPageLength == 30">30</option>
                        <option [selected]="currentPageLength == 50">50</option>
                        <option [selected]="currentPageLength == 100">
                          100
                        </option>
                        <option [selected]="currentPageLength == 500">
                          500
                        </option>
                        <option [selected]="currentPageLength == 1000">
                          1000
                        </option>
                      </select>
                      &nbsp;
                      <span> entries</span>
                    </div>
                  </div>
                </div>

                <table
                  *ngIf="bookings"
                  class="
                    table
                    table-bordered
                    table-condensed
                    table-responsive-sm
                    table-responsive-md
                    table-responsive-lg
                    table-responsive-xl
                    nowrap
                  "
                  datatable
                  [dtOptions]="dtOptions"
                  width="100%"
                >
                  <thead class="">
                    <tr>
                      <th scope="col">S/N</th>
                      <th scope="col">Date</th>
                      <th scope="col">Time</th>
                      <th scope="col">Day</th>
                      <th scope="col">Passenger Name</th>
                      <th scope="col">Appointment ID</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Email</th>
                    </tr>
                  </thead>
                  <tbody class="dashboard-bg-white">
                    <tr
                      *ngFor="
                        let booking of bookings | paginate: config;
                        index as i
                      "
                    >
                      <th scope="row">
                        {{
                          config.itemsPerPage * (config.currentPage - 1) + i + 1
                        }}
                      </th>
                      <td>{{ booking.booking_date }}</td>
                      <td>{{ booking.booking_time }}</td>
                      <td>{{ booking.booking_date | date: "EEEE" }}</td>
                      <td>
                        {{ booking.first_name }} {{ booking.middle_name }}
                        {{ booking.last_name }}
                      </td>
                      <td>{{ booking.appointment_id }}</td>
                      <td>{{ booking.phone }}</td>
                      <td>{{ booking.email }}</td>
                    </tr>
                  </tbody>
                </table>

                <div class="table-footer">
                  <div
                    id="page_info"
                    class="mt-3 record-show-text-bottom"
                    *ngIf="bookings"
                  >
                    Showing
                    {{ (config.currentPage - 1) * config.itemsPerPage + 1 }} -
                    {{ config.currentPage * config.itemsPerPage }} of
                    {{ config.totalItems }} entries
                  </div>

                  <div class="pagination paging-pull-right" *ngIf="bookings">
                    <pagination-controls
                      (pageChange)="pageChange($event)"
                      class="my-pagination mt-2 pagination-server"
                    >
                    </pagination-controls>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer-dashboard></app-footer-dashboard>
